// Scavenger Hunt visibility window:
// - Tab is visible up to and including end of day 4/25/2026 (local time)
// - At 4/26/2026 00:00 local, the tab disappears completely.
export const SCAVENGER_HUNT_HIDE_AT = new Date(2026, 3, 26, 0, 0, 0, 0).getTime();

export function isScavengerHuntVisible(now = Date.now()) {
  return now < SCAVENGER_HUNT_HIDE_AT;
}
